import { eyeIcon } from '../../../config/variables';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { useNavigate } from 'react-router-dom';

export default function FinancingApplicationsTableItem({ item }: { item: any }) {
  const navigate = useNavigate();

  const hasEditPermission = hasPermission(['locations.edit']);

  return (
    <div
      className={`item has_logo financing_applications ${hasEditPermission && 'clickable'}`}
      key={item.id}
      onClick={(e) => {
        hasEditPermission && navigateRoute(e, `/financing-applications/${item.id}`, navigate);
      }}
    >
      <div className="column">{item?.id || '-'}</div>
      <div className="column">
        <div className="capitalize">{item?.variant?.vehicle_model?.name || '-'}</div>
      </div>
      <div className="column">
        <div className="capitalize">{item?.user?.first_name || item?.user?.last_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : '-'}</div>
      </div>
      <div className="column">{item?.salary ? Number(item?.salary)?.toLocaleString('en-US') : '-'}</div>
      <div className="column">{item?.job_title || '-'}</div>
      <div className="column">{item.status}</div>
      {hasPermission(['orders.edit']) && (
        <div className="column actions actions_col">
          <div
            className="action_btn edit"
            onClick={(e) => {
              navigateRoute(e, `/financing-applications/${item.id}`, navigate);
            }}
          >
            {eyeIcon}
          </div>
        </div>
      )}
    </div>
  );
}
